var Cell = /*@__PURE__*/ (function () {
    function Cell(day, month) {
        var _this = this;
        this.activate = function () {
            jQuery(_this.element).addClass(Cell.ACTIVE_CLASS);
        };
        this.deactivate = function () {
            jQuery(_this.element).removeClass(Cell.ACTIVE_CLASS);
        };
        this.enable = function () {
            _this.enabled = true;
            jQuery(_this.element).removeClass(Cell.DISABLED_CLASS);
        };
        this.disable = function () {
            _this.enabled = false;
            jQuery(_this.element).addClass(Cell.DISABLED_CLASS).off('click');
        };
        this.isEnabled = function () {
            return _this.enabled;
        };
        this.remove = function () {
            jQuery(_this.element).remove();
        };
        this.createHTMLElement = function () {
            var element = jQuery(Cell.HTML).html(_this.day.toString()).get(0);
            _this.element = element;
        };
        this.getElement = function () {
            return _this.element;
        };
        this.onClick = function (callback) {
            _this.clickEvt = callback;
            jQuery(_this.element).on('click', function () {
                if (!jQuery(_this.element).hasClass('next-month')) {
                    _this.clickEvt(_this.day, _this.month);
                }
            });
        };
        this.day = day;
        this.month = month;
        this.createHTMLElement();
    }
    Cell.HTML = "<div class=\"td cell\"></div>";
    Cell.ACTIVE_CLASS = 'selected-day';
    Cell.DISABLED_CLASS = 'next-month';
    return Cell;
}());
export default Cell;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/plugins/DatePicker/Cell.ts
// module id = null
// module chunks = 